import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=6c5a6eac&functional=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"
import style0 from "./InstagramFeed.vue?vue&type=style&index=0&id=6c5a6eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports